import type { LocaleCode } from '@pba/react-utils';

export const appLanguageCodes = ['en', 'es'] as const;

export type AppLanguage = (typeof appLanguageCodes)[number];

export const locales: Record<AppLanguage, LocaleCode> = {
  en: 'en-US',
  es: 'es-ES',
};
